export const closeEmergency = id => dispatch => {
	dispatch({
		type: 'CLOSE_EMERGENCY',
		id
	})
}
